import { isNativeDateInputSupported } from "~/plugins/utilities/browser-support/browserSupport";

export default (context) => {
  context.store.commit("SET_BROWSER_SUPPORT", {
    hasNativeDateInput: isNativeDateInputSupported(window),
  });
};
